import { render, staticRenderFns } from "./MasterMeal.vue?vue&type=template&id=04edbaec&scoped=true&"
import script from "./MasterMeal.vue?vue&type=script&lang=js&"
export * from "./MasterMeal.vue?vue&type=script&lang=js&"
import style0 from "./MasterMeal.vue?vue&type=style&index=0&id=04edbaec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04edbaec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
